/** Replace spaces so S3 keys and public URLs stay valid. */
export function sanitizeUploadFileName(name) {
  return String(name ?? "")
    .trim()
    .replace(/\s+/g, "_");
}

/** Return the same file with a URL-safe name when the original has spaces. */
export function fileWithSafeName(file) {
  if (!file) return file;
  const safeName = sanitizeUploadFileName(file.name);
  if (!safeName || safeName === file.name) return file;
  return new File([file], safeName, {
    type: file.type,
    lastModified: file.lastModified,
  });
}
